// extracted by mini-css-extract-plugin
export default {"art":"Art_art__QBpCp","notVisible":"Art_notVisible__O6UWs"};